
import footballCom from "../../../assets/images/bet.jpg";
import defaultImage from "../../../assets/images/bet.jpg";


import bet9ja from "../../../assets/icons/Bet9ja Logo.svg";
import x9ja from "../../../assets/images/1xbet.png";
import msport from "../../../assets/images/msport.png";
import betwise from "../../../assets/images/betwise.png";
import betway from "../../../assets/images/betway.png";
import winnersgoldenchance from "../../../assets/images/winnersgoldenchance.jpg";
import betbaba from "../../../assets/images/betbaba.jpg";
import accessbet from "../../../assets/images/accessbet.jpg";
import betland from "../../../assets/images/betland.jpg";
import livescorebet from "../../../assets/images/livescorebet.png";
import xbet from "../../../assets/images/1xbet.png";
import sportybet from "../../../assets/images/sportybet.jpg";
import lotto from "../../../assets/images/25lotto.jpg";
import surebet from "../../../assets/images/surebet.jpg";
import merrybet from "../../../assets/images/merrybet.png";
import hallabet from "../../../assets/images/hallabet.jpg";
import greenlotto from "../../../assets/images/greenlotto.jpg";
import eliestlotto from "../../../assets/images/eliestlotto.png";
import betking from "../../../assets/images/betking.jpg";
import nairabet_old from "../../../assets/images/nairabet_old.png";
import zoomlifestyle from "../../../assets/images/zoomlifestyle.png";
import bangbet from "../../../assets/images/bangbet.png";
import allcitybet from "../../../assets/images/allcitybet.jpg";
import cashtoken from "../../../assets/images/cashtoken.jpg";
import nairabet from "../../../assets/icons/Nairabet Logo.svg";
import westernlotto from "../../../assets/images/western_lotto.png";
import mlotto from "../../../assets/images/mlotto.webp";
import cloudbet from "../../../assets/icons/cloudbet.jpg";
import betting from "../../../assets/images/football.svg";

const generateBettingProviderImageUrl = (providerSlug) => {
  
 // image srcs
  const providerImages = 
    {
      Bet9ja: bet9ja,
      ZoomLifeStyle: zoomlifestyle,
      CashToken: cashtoken,
      MLotto: mlotto,
      WesternLotto: westernlotto,
      AllCityBet: allcitybet,
      BangBet: bangbet,
      NairaBet_old: nairabet_old,
      BetKing: betking,
      GreenLotto: greenlotto,
      EliestLotto: eliestlotto,
      HALLABET: hallabet,
      BetWay: betway,
      MerryBet: merrybet,
      SureBet: surebet,
      '25Lotto': lotto,
      SportyBet: sportybet,
      '1xbet': xbet,
      livescorebet: livescorebet,
      Betland: betland,
      Cloudbet: cloudbet,
      AccessBet: accessbet,
      Nairabet: nairabet,
      BetBaba: betbaba,
      "Winners Golden Chance": winnersgoldenchance,
      Betwize: betwise,
      MSport: msport,
      FootballCom: betting,
    };

    return providerImages[providerSlug] || defaultImage;
};

export default generateBettingProviderImageUrl;

